import React from 'react';
import { injectIntl } from "react-intl";
import { useRouteMatch } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import searchParamsStringify from "@Utils/searchParamsStringify";

function ViewSwitcher({intl, resultsTotal, searchParams}) {
  const route = useRouteMatch();
  const history = useHistory();
  let from = 1;
  let to = process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE;
  if (searchParams.page && searchParams.page > 1) {
    from += (searchParams.page - 1) * process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE;
    to = searchParams.page * process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE;
  }

  const branchViewChange = (event) => {
    if (event.currentTarget.name !== "list") {
      searchParams.type = event.currentTarget.name;
    }
    else {
      searchParams.type = null;
    }
    const baseUrl = route.path.replace(":searchParams*", "");
    const params = searchParamsStringify(searchParams);
    history.push(`${baseUrl}${params}`)
  };

  return (
    <div className="wrapper">
      <div className="sortbar sortbar--toggle">
        <span className="sortbar__count text-ellipsis">{intl.formatMessage({id: "ViewSwitcher.Count"}, {
          from: from,
          to: to,
          total: resultsTotal
        })}</span>
        <div className="toggable-group">
          <button className={`button--clean toggable-group__item ${!searchParams.type ? "toggable-group__item--active" : ""}`}
                  onClick={branchViewChange} name="list" aria-label={intl.formatMessage({ id: "ViewSwitcher.ListLabel.AccessibilityAriaLabel" })}>
            <span className="icon icon--inline">
              <svg>
                <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#bullet-list"/>
              </svg>
            </span>
            <span>{intl.formatMessage({id: "ViewSwitcher.ListLabel"})}</span>
          </button>
          <button className={`button--clean toggable-group__item ${searchParams.type === "map" ? "toggable-group__item--active" : ""}`}
                  onClick={branchViewChange} name="map" aria-label={intl.formatMessage({ id: "ViewSwitcher.MapLabel.AccessibilityAriaLabel" })}>
            <span className="icon icon--inline">
              <svg>
                <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#marker"/>
              </svg>
            </span>
            <span>{intl.formatMessage({id: "ViewSwitcher.MapLabel"})}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(ViewSwitcher);
